<div class="panel panel-plan bordered">

	<div class="row">
		<div class="col-12">
			<div class="w-100">
				<div class="stepper pe-0 mb-4">
					<div class="stepper-icon" [class.success]="formCtrl.anatomicalSite.valid">
						a<i class="material-icons">done</i>
					</div>
					<div data-testid="SUBSYS2_PLANFORM_SKELETON_TITLE_TXT" class="stepper-label"
						[title]="labels().PLAN_FORM_COMPONENT_ANALYSIS_TYPE">
						{{ labels().PLAN_FORM_COMPONENT_ANALYSIS_TYPE }} &nbsp; *
					</div>
				</div>
				@if (formCtrl.anatomicalSite.errors && (formCtrl.anatomicalSite.touched ||
				formCtrl.anatomicalSite.hasError('pattern'))) {
				<div class="invalid-feedback d-block mb-4">
					{{ formCtrl.anatomicalSite | validationMsg:errorMsgs.anatomicalSite | async }}
				</div>
				}
				<div class="skeleton-wrapper">
					@if (!isSkeletonLoading) {
					<bone-selection [disabled]="isDisabled" [site]="formValue.anatomicalSite!"
						[availableSites]="availableSkeletonSites" (siteChanged)="updateAnatomicalSite($event)" />
					} @else {
					<img class="w-100" src="images/bilateralPlan.png" alt="skeleton">
					}
				</div>
				@if (formValue.anatomicalSite) {
				<label data-testid="SUBSYS2_PLANFORM_ANALYSISTYPE_TXT" class="label-bone-type mt-0" for="anatomicalSite"
					[class.text-danger]="formCtrl.anatomicalSite.invalid">
					{{ formValue.anatomicalSite! | anatomicalSiteLabel | uppercase }}
				</label>
				}
			</div>
		</div>

	</div>
</div>